import { render, staticRenderFns } from "./List.vue?vue&type=template&id=35c4be93&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=35c4be93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c4be93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c4be93')) {
      api.createRecord('35c4be93', component.options)
    } else {
      api.reload('35c4be93', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=35c4be93&scoped=true&", function () {
      api.rerender('35c4be93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MobileViews/ValidateTsDetails/List.vue"
export default component.exports